/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'box': {
    width: 23.32,
    height: 21.5,
    viewBox: '0 0 23.32 21.5',
    data: '<path pid="0" d="M11.518 4.266v3.7H8.39v-3.7H6.684v4.55a.853.853 0 00.853.853h4.835a.853.853 0 00.853-.853v-4.55z" _fill="#959595"/><path pid="1" d="M22.467 0H4.266a.853.853 0 00-.6.25L.25 3.663a.853.853 0 00-.25.6v16.384a.853.853 0 00.853.853h18.2a.853.853 0 00.6-.25l3.413-3.413a.852.852 0 00.25-.6V.853A.853.853 0 0022.467 0zm-.853 16.881L18.7 19.794H1.706V4.619l2.913-2.913h16.995v15.175z" _fill="#959595"/><path pid="2" d="M21.864.25l-3.163 3.163H.853v1.706h18.2a.852.852 0 00.6-.25l3.413-3.413z" _fill="#959595"/><path pid="3" _fill="#959595" d="M18.201 4.266h1.706v16.381h-1.706z"/>'
  }
})
